// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import useThrottledCallback from 'hooks/throttledCallback';
import styles from './PlaybackButton.module.scss';

const PlaybackButton = ({ onSelect, focusId, className, ttsText, render }) => {
  const selectFunc = useThrottledCallback(onSelect, 200);

  return (
    <Selectable
      focusId={focusId}
      onSelect={selectFunc}
      className={className}
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <button
          type="button"
          data-testid="playback-button"
          onClick={onSelect}
          className={classNames(
            'bg-transparent',
            'd-flex',
            'justify-content-center',
            'align-items-center',
            styles.buttonWrapper,
          )}
        >
          {render(hasFocus)}
        </button>
      )}
    />
  );
};

PlaybackButton.propTypes = {
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  className: PropTypes.string,
  ttsText: PropTypes.string,
  render: PropTypes.func.isRequired,
};

PlaybackButton.defaultProps = {
  onSelect: () => {},
  focusId: null,
  className: null,
  ttsText: null,
};

export default React.memo(PlaybackButton);
